import { render, staticRenderFns } from "./NuevoRiegos.vue?vue&type=template&id=68424484&scoped=true"
import script from "./NuevoRiegos.vue?vue&type=script&lang=js"
export * from "./NuevoRiegos.vue?vue&type=script&lang=js"
import style0 from "../../../assets/scss/multiselect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../../assets/scss/vue-select.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../../../assets/scss/tree-select.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "spinkit/spinkit.min.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./NuevoRiegos.vue?vue&type=style&index=4&id=68424484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68424484",
  null
  
)

export default component.exports